import { stringKeyToTuple } from 'js/lib/stringKeyTuple';

import type { ProductOwnershipFragment } from 'bundles/enroll/utils/queries/__generated__/GetProductOwnershipQuery';

export type FormattedGraphqlProductOwnership = {
  expiredOwns: boolean;
  id: string;
  owns: boolean;
  productId: string;
  productType?: string;
  s12nCourseOwnerships?: { courseId: string; owns: boolean }[] | null;
  userId: number;
  unownedCourses?: string[];
  expiresAt?: number | null;
  firstOwnedAt?: number | null;
  lastUpdated?: number | null;
};

const toMilliseconds = (time?: { seconds: string; nanos: number } | null) => {
  if (!time) {
    return undefined;
  }

  const milliseconds = Number(time.seconds) * 1e3 + time.nanos * 1e-6;
  return milliseconds;
};

export const formatGraphqlProductOnwership = (
  productOwnerships?: ProductOwnershipFragment | null
): FormattedGraphqlProductOwnership | undefined => {
  if (!productOwnerships) {
    return undefined;
  }

  const { expiredOwns, id, s12nCourseOwnerships, owns, expiresAt, firstOwnedAt, lastUpdatedTime } = productOwnerships;
  const [userId, productType, productId] = stringKeyToTuple(productOwnerships.id);
  const unownedCourses = s12nCourseOwnerships?.filter(({ owns: _owns }) => !_owns).map(({ courseId }) => courseId);

  return {
    expiredOwns,
    id,
    owns,
    productId,
    productType,
    s12nCourseOwnerships: s12nCourseOwnerships ?? undefined,
    userId: Number(userId),
    unownedCourses,
    expiresAt: toMilliseconds(expiresAt),
    firstOwnedAt: toMilliseconds(firstOwnedAt),
    lastUpdated: toMilliseconds(lastUpdatedTime),
  };
};
